import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlExcelState {
    data: Blob | null;
}

export const initialState: DlExcelState = { data: null };

export const dlExcelReducer = createReducer(
    initialState,
    on(driverLicenseActions.getExcelSuccess, (state, { payload }) => ({ ...state, data: payload })),
    on(driverLicenseActions.clearExcel, () => initialState)
);
